import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_31: FaireProductEntity = {
  token: "legacy_prod_abbott-31",
  type: "product",
  name: 'Tall Bud Vase Dark Blue 7.5" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/dccb1946af1d1a436f9eae9b0937a6b54e4db24dc5a4c3d4307accf1c9eb1f0b.jpeg",
  priceDollars: 18,
  subcategory: "Vases & Vessels",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
